import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'
import { useLoadScript } from '@react-google-maps/api'

import UserAddressPinpoint from 'domains/sales/deals/organisms/address-pinpoint/user-address-pinpoint'

const PLACE_LIBRARIES = ['places']

const LazyUserAddressPinpoint = (props) => {
  const { isLoaded, loadError } = useLoadScript({
    id: 'sales-users-address-pinpoint-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: PLACE_LIBRARIES,
  })

  if (loadError) {
    return <Alert color="danger">Gagal load Google Map.</Alert>
  }

  if (!isLoaded) {
    return <div className="text-muted">Loading Google Map...</div>
  }

  return <UserAddressPinpoint {...props} />
}

LazyUserAddressPinpoint.propTypes = {
  provinceName: PropTypes.string,
  cityName: PropTypes.string,
  districtName: PropTypes.string,
  fullAddress: PropTypes.string,
  lat: PropTypes.number,
  long: PropTypes.number,
  onSubmitCoordinates: PropTypes.func,
  closePinpoint: PropTypes.func.isRequired,
}

export default LazyUserAddressPinpoint